import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {Container} from "reactstrap";

import Input from "../../components/input/input";
import Button from "../../components/button/button";
import {createOrganization} from "../../../modules/organization";
import {setPageTitle} from "../../../modules/application/pages";

import "./organization-form.css";

class OrganizationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            notes: "",
        };
    }

    componentWillMount() {
        this.props.dispatch(setPageTitle("Create Organization"));
    }

    submitOrganization() {
        this.props.dispatch(createOrganization(this.state));
        this.props.history.push(`/?message=Added organization! ${this.state.name}&title=Overview`);
    }

    render() {
        return (
            <Container style={{float: "left"}}>
                <h1>Create Organization</h1>
                <div className="Organization-form">
                    <div className="Organization-inputs">
                        <Input
                            name="name"
                            value={this.state.name}
                            onChange={name => {
                                this.setState({name});
                            }}
                            label="Name"
                            field="name"
                        />
                    </div>
                    <div className="Organization-inputs">
                        <Input
                            name="notes"
                            value={this.state.note}
                            onChange={notes => {
                                this.setState({notes});
                            }}
                            label="Notes"
                            field="notes"
                        />
                    </div>
                    <div className="Organization-button">
                        <Button
                            text="Create Organization"
                            onClick={() => {
                                this.submitOrganization();
                            }}
                            color="primary"
                        />
                    </div>
                </div>
            </Container>
        )
    }
}


const withState = connect(() => {
    return {};
});
export default withRouter(withState(OrganizationForm));



// WEBPACK FOOTER //
// ./src/components/containers/organization-form/organization-form.js